export default __webpack_public_path__ + "static/media/icon-folder.ca59d345.svg";